import { isTestEnv } from '@hlj/hlj-utils'
import { STATISTIC_NAME } from '@constant'
import hljStatistic from '@hlj/hlj-statistic'
import { getMerchantInfo } from '..'
import * as Sentry from '@sentry/browser'

/**
 * 埋点方法，参数参考
 * http://git.hljnbw.cn/WEB_GROUP/hlj-statistic
 */
export const HLJ_STATISTIC = (params = {}) => {
  hljStatistic({
    app_name: 'web',
    user_id: getMerchantInfo().id,
    ...params
  })
}

export const STAT_HIT = (params = {}) => {
  const merchantId = getMerchantInfo().id
  HLJ_STATISTIC({
    event_type: 'element_hit',
    data_id: merchantId,
    data_type: 'Merchant',
    ...params
  })
}

/**
 *  poster 埋点
 */
export const statisticPoster = (id, event_type = 'element_hit') => {
  // 开发模式、测试环境不发送
  if (__DEV__ || isTestEnv() || !id) return

  HLJ_STATISTIC({
    data_id: id,
    data_type: 'Poster',
    event_type
  })
}

/**
 *  TODO，这个需移除，后续都使用 HLJ_STATISTIC
 */
export const statistic = (position, type = 'click', params = {}) => {
  if (!__DEV__) {
    // eslint-disable-next-line no-undef
    STATIC.sdk(STATISTIC_NAME, position, type, {
      merchant_id: getMerchantInfo().id,
      ...params
    })
  }
}

export const getStatPromotionParams = item => {
  const { id, budget_type, daily_budget, entity_type, thousand_budget } =
    item || {}

  return {
    id,
    budget_type,
    daily_budget,
    entity_type,
    thousand_budget
  }
}

export const sendEnrichDataToSentry = error => {
  const { sentryUser, simpleMerchantData } = getSentryData()
  Sentry.captureException(error, scope => {
    scope.clear()
    scope.setUser(sentryUser)
    scope.setTag('isErrorBoundary', true)
    scope.setExtra('merchantInfo', simpleMerchantData)
  })
}
export const getSentryData = () => {
  const merchant = getMerchantInfo() || {}
  const sentryUser = {
    id: merchant.id,
    username: merchant.name
  }
  const simpleMerchantData = {
    id: merchant.id,
    name: merchant.name,
    userId: merchant.user_id,
    city: merchant.city,
    mobile: merchant.contact_mobile
  }
  return { sentryUser, simpleMerchantData }
}
